import { requestToken } from "./request_method";

const BASE = `${process.env.REACT_APP_NODE_URL}/api/targets`;

const targetsApi = {
  getEmployeesForTargets() {
    return requestToken.get(`${BASE}/employees-for-targets`);
  },

  getMeSummary(year, month) {
    return requestToken.get(`${BASE}/me-summary`, { year, month });
  },

  getEmployeeSummary(userId, year, month) {
    return requestToken.get(`${BASE}/employee-summary`, { userId, year, month });
  },

  getDailyReport(date, userId) {
    const params = { date };
    if (userId != null) params.userId = userId;
    return requestToken.get(`${BASE}/daily-report`, params);
  },

  getSidebarSummary(year, month) {
    return requestToken.get(`${BASE}/sidebar-summary`, { year, month });
  },

  getReport(payload) {
    const { period = "month", year, month, weekIndex } = payload || {};
    const params = { period, year };
    if (period !== "annual") params.month = month;
    if (period === "week") params.weekIndex = weekIndex;
    // Backend expects query params like: /api/targets/report?period=month&year=2026&month=3
    return requestToken.get(`${BASE}/report`, params);
  },

  setMonthlyTarget(payload) {
    return requestToken.post(`${BASE}/monthly`, payload);
  },

  deleteMonthlyTarget(params) {
    return requestToken.post(`${BASE}/monthly-delete`, params);
  },

  logActivity(payload) {
    return requestToken.post(`${BASE}/activity-log`, payload);
  },

  getActivities() {
    return requestToken.get(`${BASE}/activities`);
  },

  createActivity(payload) {
    return requestToken.post(`${BASE}/activities`, payload);
  },

  getEnquiryCategories() {
    return requestToken.get(`${BASE}/enquiry-categories`);
  },
};

export default targetsApi;

